import React from "react";
import { Link2, BarChart3, Zap } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Link2,
    title: "Connect your gig platforms",
    blurb:
      "Link DoorDash, Uber, Lyft, Instacart, Spark, Roadie, and more. Secure, read-only access.",
  },
  {
    n: "02",
    icon: BarChart3,
    title: "We verify your earnings activity",
    blurb:
      "GigAfloat analyzes verified earnings patterns across your connected platforms. No traditional credit score required.",
  },
  {
    n: "03",
    icon: Zap,
    title: "Get a Float when you need it",
    blurb:
      "Access an earnings-based Float between payouts upon approval and repay through future earnings activity.",
  },
];

const HowItWorks = () => (
  <section id="how" className="relative py-24 md:py-32 border-t border-white/5 bg-[#070707]" data-testid="how-it-works">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="flex items-end justify-between flex-wrap gap-6 mb-16">
        <div>
          <div className="font-mono-c text-[10px] uppercase tracking-[0.25em] text-[#00FF88] mb-4">
            // How it works
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.02]">
            Three steps. <span className="text-white/40">Zero stress.</span>
          </h2>
        </div>
      </div>

      <div className="relative grid md:grid-cols-3 gap-6 md:gap-0">
        {/* connecting line */}
        <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-[#00FF88]/40 to-transparent" />

        {steps.map((s, i) => {
          const Icon = s.icon;
          return (
            <div key={s.n} className="relative px-6 md:px-8" data-testid={`step-${s.n}`}>
              <div className="w-24 h-24 mx-auto mb-6 relative">
                <div className="absolute inset-0 rounded-full bg-[#00FF88]/10 blur-2xl" />
                <div className="relative w-full h-full rounded-3xl bg-[#0A0A0A] border border-[#00FF88]/30 grid place-items-center edge-glow">
                  <Icon className="w-9 h-9 text-[#00FF88]" />
                </div>
                <div className="absolute -top-3 -right-3 w-10 h-10 rounded-full bg-[#00FF88] text-black font-display font-extrabold grid place-items-center text-sm">
                  {s.n}
                </div>
              </div>
              <h3 className="font-display text-2xl font-extrabold text-center mb-2">{s.title}</h3>
              <p className="text-white/55 text-center leading-relaxed max-w-xs mx-auto">{s.blurb}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default HowItWorks;
